import Vue from 'vue'
import Router from 'vue-router'
const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router)
var routes=[
	{
		path:'/',
		redirect:'/index'
	},
	{
		path: '/',
		name: '',
		component: both("Home"),
		children: [
			{
				path: 'index',
				component: both("index"),
				name: '首页'
			},
			{
				path: 'product',
				component: both("product"),
				name: '产品'
			},
			{
				path: 'patent',
				component: both("patent"),
				name: '专利'
			},
			{
				path: 'partner',
				component: both("partner"),
				name: '合作伙伴'
			},
			{
				path: 'news',
				component: both("news"),
				name: '新闻'
			},
			{
				path: 'info',
				component: both("info"),
				name: '新闻详情'
			},
			{
				path: 'contact',
				component: both("contact"),
				name: '联系我们'
			},
			{
				path: 'search',
				component: both("search"),
				name: '搜索'
			}
		],
	},
];
export default routes;


// WEBPACK FOOTER //
// ./src/router/index.js